import { AIConversationOriginType } from '../../constants/aiAgents'
import { EMPTY_STRING } from '../../constants/common'

import {
  getIsGretaAIChatAssistantRole,
  getIsGretaAIChatThinking,
} from './GretaAIChat.utils'
import {
  getIsGretaAIChatFinanceSource,
  getIsGretaAIChatNewChat,
} from './GretaAIChat.utils.source'

export function getGretaAIChatAskElsewhereTarget({
  isFinanceAvailable,
  isSourceChoiceEnabled,
  messages,
  source,
  status,
}) {
  const suggestSource = messages.at(-1)?.suggestSource ?? null

  if (
    !isSourceChoiceEnabled ||
    !suggestSource ||
    suggestSource === source ||
    getIsGretaAIChatThinking(status)
  ) {
    return null
  }

  return getIsGretaAIChatFinanceSource(suggestSource) && !isFinanceAvailable
    ? null
    : suggestSource
}

export function getGretaAIChatAskElsewhereOrigin(chatId) {
  return {
    from_conversation_id: chatId,
    type: AIConversationOriginType.AskElsewhere,
  }
}

export function getGretaAIChatLastQuestionText(messages) {
  return (
    messages.findLast(message => !getIsGretaAIChatAssistantRole(message.role))
      ?.text ?? EMPTY_STRING
  )
}

// A send still waiting for its balance check would swallow the question.
export function getIsGretaAIChatAskElsewhereReady({
  activeChatId,
  isSendPending,
  messages,
  request,
}) {
  return (
    Boolean(request) &&
    !isSendPending &&
    getIsGretaAIChatNewChat(activeChatId) &&
    messages.length === 0
  )
}
